import { NextSeo } from 'next-seo';
import Layout from '@components/common/Layout';
import { getAllProjectsForHome } from '@lib/api';
import { ProjectCard } from '@components/project';

export default function Projects({ allProjects }) {
  return (
    <>
      <NextSeo
        title="Electrical projects completed near me in Maricopa, Casa Grande, Chandler and Ahwatukee Arizona"
        description="HLB Electric has completed projects all over the Phoenix Metropolitan area including installing Ceiling fans, lighting upgrades, new electrical outlets and more!"
        canonical="https://www.hlbelectric.com/projects"
        openGraph={{
          title:
            'Electrical projects completed near me in Maricopa, Casa Grande, Chandler and Ahwatukee Arizona | HLB Electric',
          description:
            'HLB Electric has completed projects all over the Phoenix Metropolitan area including installing Ceiling fans, lighting upgrades, new electrical outlets and more!',
          url: 'https://www.hlbelectric.com/projects',
        }}
      />
      <div className="bg-white">
        <div className="max-w-2xl mx-auto py-8 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-6xl">
            Projects
          </h1>

          <div className="mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
            {allProjects.map((project) => (
              <ProjectCard
                project={project}
                key={project.slug}
                className="animated fadeIn"
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export async function getStaticProps({ preview = false }) {
  const allProjects = await getAllProjectsForHome(preview);
  return {
    props: {
      allProjects,
    },
    revalidate: 86400,
  };
}

Projects.Layout = Layout;
